/**
 * Admin Agents API client (Phase 28.10).
 *
 * All endpoints are gated server-side on the `admin` Cognito group.
 * PUT responses are classified by the backend (prompt-only → 200, structural → 202 + prUrl).
 */

import { request } from "./api.js";

export const listAdminAgents = () => request("/api/admin/agents");

export const getAdminAgent = (agentId) =>
  request(`/api/admin/agents/${encodeURIComponent(agentId)}`);

export const createAdminAgent = (payload) =>
  request("/api/admin/agents", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const updateAdminAgent = (agentId, payload) =>
  request(`/api/admin/agents/${encodeURIComponent(agentId)}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const deleteAdminAgent = (agentId) =>
  request(`/api/admin/agents/${encodeURIComponent(agentId)}`, {
    method: "DELETE",
  });

export const listPendingAgentPRs = () =>
  request("/api/admin/agents/pending-prs");
